import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const TrainPictogram = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11.3484 10.9884V2.80837C11.3484 1.25728 10.0914 0 8.54006 0H2.80838C1.25759 0 0 1.25728 0 2.80837V10.9884C0 12.1643 0.855719 13.144 1.97716 13.3391L0.215906 16H1.78184L2.50472 14.9075H8.84431L9.56716 16H11.1328L9.37188 13.3391C10.493 13.1438 11.3484 12.1643 11.3484 10.9884ZM3.24241 1.26087H8.10603V2.0715H3.24241V1.26087ZM1.77906 3.88081C1.77906 3.52819 2.06459 3.24213 2.41722 3.24213H8.93147C9.28385 3.24213 9.56988 3.52819 9.56988 3.88081V6.57475C9.56988 6.92737 9.28381 7.21316 8.93147 7.21316H2.41725C2.06462 7.21316 1.77909 6.92737 1.77909 6.57475V3.88081H1.77906ZM2.38697 11.6876C1.97578 11.6876 1.64241 11.3543 1.64241 10.9433C1.64241 10.5318 1.97578 10.1984 2.38697 10.1984C2.79819 10.1984 3.13156 10.5318 3.13156 10.9433C3.13156 11.3543 2.79819 11.6876 2.38697 11.6876ZM2.97478 14.1973L3.51884 13.3748H7.82988L8.37394 14.1973H2.97478ZM8.96175 11.6876C8.55056 11.6876 8.21719 11.3543 8.21719 10.9433C8.21719 10.5318 8.55056 10.1984 8.96175 10.1984C9.37297 10.1984 9.70635 10.5318 9.70635 10.9433C9.70635 11.3543 9.37297 11.6876 8.96175 11.6876Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 11.3484 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { TrainPictogram };